<template>
  <div class="m_container_box" :style="backgroundDiv">
      <div class="m_top_box">
        <div class="m_top_img_box"><img :src="titleImgSrc" width="100%" height="100%" /></div>
        <div class="m_top_title">RIDE TO THE TOP</div>
        <div class="m_top_subtitle">EPISODE 3</div>
        <div class="m_title_time">{{laveDay}}<span>days</span>{{laveHours}}
            <span>hrs</span>{{laveMinutes}}<span>mins</span>{{laveSeconds}}<span>secs left</span>
        </div>
        <div class="m_top_three_box">
          <div class="m_top_two">
            <div class="m_top_two_no"><img :src="rankNoSencodSrc" width="100%" height="100%" /></div>
            <div class="m_top_two_avator">
              <img :src="topThreeList[1].userAvatar" width="100%" height="100%" class="m_top_two_avator_img" />
            </div>
            <div class="m_top_two_name">{{topThreeList[1].userName}}</div>
            <div class="m_top_two_score">{{topThreeList[1].score}}</div>
          </div>

          <div class="m_top_one">
            <div class="m_top_one_no"><img :src="rankNoFirstSrc" width="100%" height="100%" /></div>
            <div class="m_top_one_avator">
              <img :src="topThreeList[0].userAvatar" width="100%" height="100%" class="m_top_one_avator_img" />
            </div>
            <div class="m_top_one_name">{{topThreeList[0].userName}}</div>
            <div class="m_top_one_score">{{topThreeList[0].score}}</div>
          </div>
          <div class="m_top_three">
            <div class="m_top_two_no"><img :src="rankNoThridSrc" width="100%" height="100%" /></div>
            <div class="m_top_three_avator">
              <img :src="topThreeList[2].userAvatar" width="100%" height="100%" class="m_top_three_avator_img" />
            </div>
            <div class="m_top_three_name">{{topThreeList[2].userName}}</div>
            <div class="m_top_three_score">{{topThreeList[2].score}}</div>
          </div>
        </div>
        <!-- <div class="m_top_des"> The prize is on the way!</div> -->
      </div>
      <div v-if="Object.keys(myself).length!=0">
        <div class="m_my_self">
          <div class="m_my_self_left">
            <div class="m_my_rank_no">{{myself.rankNum}}</div>
            <div class="m_my_rank_current">You Currently Rank</div>
          </div>
          <div class="m_my_rank_points">{{myself.score}}</div>
        </div>
      </div>
      <div class="m_rank_content">
        <div class="m_rank_title_box">
          <div class="m_rank_no_name">
            <div class="m_rank_title_no">Rank</div>
            <div class="m_rank_title_name">Username</div>
          </div>
          <div class="m_rank_title_points">Points</div>
        </div>
        <div v-for="(item, index) in ranksList" :key="index">
          <div class="m_rank_item_box">
            <div class="m_rank_no">{{item.rankNum }}</div>
            <div class="m_rank_avatar">
              <img :src="item.userAvatar" width="100" height="100" class="m_rank_avatar_img" />
            </div>
            <div class="m_rank_name">{{item.userName}}</div>
            <div class="m_rank_points">{{item.score}}</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import http from '../api/http';
  import {
    Message
  } from 'element-ui';
  import utils from '../utils/numberUtils';
  export default {
    name: 'TotalRanking',
    data() {
      return {
        backgroundDiv: {
          backgroundImage: 'url(' + require('../assets/mobile-rank-bg.png') + ')'
        },
        titleImgSrc: require('../assets/match-title.png'),
        rankNoFirstSrc: require('../assets/number-1.png'),
        rankNoSencodSrc: require('../assets/number-2.png'),
        rankNoThridSrc: require('../assets/number-3.png'),
        upSrc: require('../assets/up_arrow.png'),
        defaultHead: require('../assets/default-head.png'),
        ranksList: [],
        topThreeList: [],
        myself: {},
        timer: null,
        endTime: 0,
        laveDay: 0,
        laveHours: 0,
        laveMinutes: 0,
        laveSeconds: 0
      }
    },
    methods: {
        async getGameInfoEvent()  {
            await http.get('client-api/v1/game/info', {}).then((res) => {
                if (res.data.code == 200) {
                    let data = res.data.data;
                    this.endTime = data.endTime;
                } else {
                    Message.error(res.data.msg);
                    return
                }
            }).catch (error => {
                Message.error(error);
            })
        },
      async getRanking() {
        let query = this.$route.query;
        let name = query.name;
        let params = {
          'userName': name
        } //wzlk client-api/v1/game/rank
        await http.get('client-api/v1/game/rank', params).then(res => {
            if (res.data.code != 200) {
              Message.error(res.data.msg)
              return
            } else {
              let resource = res.data.data
              var newList = []
              var newArray = []

              resource.forEach((item, index) => {
                var map = item
                map['score'] = utils.numberFormat(item.score)
                if (index < 3) {
                  newList.push(map)
                } else {
                  newArray.push(map)
                }
                if (item.userName == name) {
                  this.myself = item
                }
              });
              if (newList.length > 1) {
                this.mTopOneAvatar = newList[0].userAvatar;
              }
              if (newList.length > 2) {
                this.mTopOneAvatar = newList[1].userAvatar;
              }
              if (newList.length > 3) {
                this.mTopOneAvatar = newList[2].userAvatar;
              }
              this.topThreeList = newList;

              this.ranksList = newArray;
            }

            console.log(res);
          })
          .catch(error => {
            throw error
          })
      },
      getCurrentTime() {
        const endTimeDate = this.endTime/1000;
        const nowTimeDate = new Date().getTime()/1000;
        if(nowTimeDate <= endTimeDate) {
          //获取时间差
          let timediff = Math.round((endTimeDate-nowTimeDate));
          //获取还剩多少天
          let day = parseInt(timediff/3600/24);
          this.laveDay = day < 10 ? '0' + day : day;
          //获取还剩多少小时
          let hours =  parseInt(timediff/3600%24);
          this.laveHours = hours < 10 ? '0' + hours : hours;
          //获取还剩多少分钟
          let minutes = parseInt(timediff/60%60);
          this.laveMinutes = minutes < 10 ? '0' + minutes : minutes;
          //获取还剩多少秒
          let seconds = timediff%60;
          this.laveSeconds = seconds < 10 ? '0' + seconds : seconds;
        }
      },
      itemsContains(val){
          return val.indexOf('http') > -1
      }
    },
    mounted() {
        this.getGameInfoEvent();
        this.timer = setInterval(() => {
            this.getCurrentTime();
        }, 1000);

        this.getRanking();
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
  }

</script>

<style scoped>
  @import '../fonts/font.css';
  .m_container_box {
    width: 100%;  
    height: 100%;
    min-width: 320px;
    max-width: 1024px;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    background-size: 100% 100%;
    position: relative;
    padding-bottom: 20px;
  }

  .m_container_bg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -2;
  }

  .m_top_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .m_top_img_box {
    width: 50%;
    margin-top: 40px;
  }

  .m_top_title {
    margin-top: 6px;
    font-size: 18px;
    color: #fff;
    font-family: Montserrat-Bold;
    font-weight: 600;
  }
  .m_top_subtitle {
    margin-top: 10px;
    font-size: 15px;
    color: rgba(255, 255, 255, 0.8);
    font-family: Montserrat-Medium;
    font-weight: 600;
  }
  .m_title_time {
    width: 100%;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    color: #4949C5;
    line-height: 32px;
    margin-top: 3px;
    font-family: DINCond-Bold;
    font-weight: bold;
    margin-left: 10px;
  }
  .m_title_time>span {
    margin-left: 5px;
    margin-right: 10px;
    color: rgb(255, 255, 255, 0.8);
    font-size: 16px;
    font-family: Montserrat-Regular;
    font-weight: normal;
  }

  .m_top_three_box {
    width: 100%;
    height: 218px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: flex-end;
  }

  .m_top_two {
    width: 25%;
    height: 70%;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .m_top_two_no {
    margin-top: -30px;
    width: 40px;
    height: 40px;
  }

  .m_top_one_no {
    margin-top: -32px;
    width: 40px;
    height: 40px;
  }
  .m_top_two_avator {
    width: 48px;
    height: 48px;
    padding: auto 28px;
    margin-top: 15px;
  }

  .m_top_two_avator_img {
    border: 2px #00BFE8 solid;
    border-radius: 50%;
  }

  .m_top_two_tag {
    width: 36px;
    height: 32px;
    position: relative;
    top: -59px;
    left: 21px;
    z-index: -2;
  }

  .m_top_two_name {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.8);
    font-weight: 400;
    margin-top: 20px;
    font-family: Montserrat-Regular;
    font-weight: 400;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .m_top_two_score {
    margin-top: 5px;
    font-size: 16px;
    font-weight: 600;
    color: #00BFE8;
    font-family: DINCond-Bold;
    font-weight: bold;
  }

  .m_top_one {
    height: 80%;
    width: 30%;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .m_top_one_avator {
    width: 58px;
    height: 58px;
    padding: 0 28px;
    margin-top: 30px;
  }

  .m_top_one_avator_img {
    border: 2px #FF9A00 solid;
    border-radius: 50%;
  }

  .m_top_one_tag {
    width: 41px;
    height: 37px;
    position: relative;
    top: -69px;
    left: 21px;
    z-index: -2;
  }

  .m_top_one_name {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.8);
    font-weight: 400;
    margin-top: 20px;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: Montserrat-Regular;
    font-weight: 400;
  }

  .m_top_one_score {
    margin-top: 6px;
    font-size: 16px;
    color: #FF9A00;
    font-family: DINCond-Bold;
    font-weight: bold;
  }

  .m_top_three {
    width: 25%;
    height: 70%;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }


  .m_top_three_avator {
    width: 48px;
    height: 48px;
    padding: 0px 28px;
    margin-top: 15px;
  }

  .m_top_three_avator_img {
    border: 2px #FF4DA3 solid;
    border-radius: 50%;
  }

  .m_top_three_tag {
    width: 36px;
    height: 32px;
    position: relative;
    top: -59px;
    left: 21px;
    z-index: -2;
  }

  .m_top_three_name {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.8);
    font-weight: 400;
    margin-top: 20px;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: Montserrat-Regular;
    font-weight: 400;
  }

  .m_top_three_score {
    margin-top: 5px;
    font-size: 16px;
    font-weight: 600;
    color: #FF4DA3;
    font-family: DINCond-Bold;
    font-weight: bold;
  }

  .m_top_des {
    margin-top: 16px;
    font-size: 14px;
    color: #fff;
    font-family: Montserrat-Regular;
    font-weight: 400;
  }

  .m_my_self {
    height: 40px;
    background-color: #303095;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: auto 18px;
    margin-top: 22px;
    border-radius: 4px;
    padding: 0px 16px;
  }

  .m_my_self_left {
    display: flex;
    flex-direction: row;
  }

  .m_my_rank_no {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    margin-left: 10px;
    font-family: Montserrat-Bold;
    font-weight: bold;
  }

  .m_my_rank_current {
    color: #fff;
    font-size: 12px;
    margin-left: 35px;
    font-family: Montserrat-Medium;
    font-weight: bold;
  }

  .m_my_rank_points {
    font-size: 18px;
    color: #FFFFFF;
    line-height: 20px;
    text-align: right;
    margin-right: 12px;
    font-family: DINCond-Bold;
    font-weight: bold;
  }

  .m_rank_content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
  }

  .m_rank_title_box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 20px;
    margin: auto 18px;
    margin-top: 18px;
  }

  .m_rank_no_name {
    display: flex;
    flex-direction: row;
  }

  .m_rank_title_no {
    font-size: 10px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);
    line-height: 13px;
    margin-left: 20px;
    font-family: Montserrat-Medium;
    font-weight: 500;
  }

  .m_rank_title_name {
    font-size: 10px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);
    line-height: 13px;
    margin-left: 58px;
    font-family: Montserrat-Medium;
    font-weight: 500;
  }

  .m_rank_title_points {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 13px;
    margin-right: 28px;
    font-family: Montserrat-Medium;
    font-weight: 500;
  }

  .m_rank_item_box {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: auto 18px;
    height: 28px;
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 4px;
    margin-top: 10px;
    padding: 6px 16px;
  }

  .m_rank_no {
    width: 10%;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    font-family: Montserrat-Medium;
    font-weight: 500;
  }

  .m_rank_avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 16px;
    margin-right: 16px;
  }

  .m_rank_avatar_img {
    width: 28px;
    height: 28px;
    border-radius: 50%;
  }

  .m_rank_name {
    width: 30%;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
    font-family: Montserrat-Regular;
    font-weight: 400;
  }

  .m_rank_points {
    width: 45%;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.8);
    text-align: right;
    padding-right: 12px;
    font-family: DINCond-Bold;
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/TotalMobileRanking.vue